import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
export var iconContainer = /*#__PURE__*/css("margin-left:", tokens.spacing.xxs, ";color:", tokens.colors.neutral.heavy.default, ";");